import React from 'react'
import { Box, IconButton, Paper, Stack, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { grey } from '@mui/material/colors'
import { useGlobalState } from 'state'
import * as utils from 'common/utils'
import { ObservatoryType, ObservatoryTypeName } from 'common/types'
import { StageDetail } from './StageDetail'
import { RainDetail } from './RainDetail'
import { CameraDetail } from './CameraDetail'
import { PumpDetail } from './PumpDetail'
import { SuijinDetail } from './SuijinDetail'
import { UnderpassDetail } from './UnderpassDetail'

export const ObservatoryContainer = () => {
  const state = useGlobalState()

  const getTitle = (): string => {
    if (state.observatory.selected === null) return ''
    const target = state.observatory.selected
    let typename = ObservatoryTypeName[target.type]
    if (target.type !== ObservatoryType.Camera) {
      typename += '観測所'
    }
    return `${typename} - ${target.name}`
  }

  const isSelectedType = (type: ObservatoryType): boolean => {
    return state.observatory.selected !== null && state.observatory.selected.type === type
  }

  React.useEffect(() => {
    fetchTimeSeries()
  }, [
    state.observatory.selected,
    state.app.baseDate
  ])

  const fetchTimeSeries = async () => {
    if (!state.observatory.selected) return
    const target = state.observatory.selected
    const date = state.app.getFormattedBaseDate(target.type === ObservatoryType.Suijin ? 0 : 5)
    const timeSeries = await utils.fetchObservatoryTimeSeries(target, date)
    state.observatory.setTimeSeries(timeSeries)
  }

  return (
    <Paper sx={{backgroundColor: grey[50], height: '100%'}} elevation={0} square>
      <Stack direction="row" alignItems={'center'} sx={{height: 36, backgroundColor: '#555fa1'}}>
        <Box flexGrow={1} padding={2}>
          <Typography variant='body2' color={grey[50]}>{ getTitle() }</Typography>
        </Box>
        <IconButton size='small' onClick={() => state.app.setObservatoryContainer(false)}>
          <CloseIcon sx={{color: grey[100]}} fontSize='small' />
        </IconButton>
      </Stack>
      <Stack
        direction="column"
        justifyContent="flex-start"
        padding={2}
        spacing={1}
        sx={{maxHeight: 'calc(100dvh - 70px)', overflowY: 'auto'}}
      >
        <Stack direction="column" color={grey[800]}>
          <Typography variant='caption'>{ state.observatory.selected?.address }</Typography>
          <Typography variant='caption'>{ state.observatory.selected?.lat },  { state.observatory.selected?.lng }</Typography>
        </Stack>
        { isSelectedType(ObservatoryType.Rain) && <RainDetail /> }
        { isSelectedType(ObservatoryType.Stage) && <StageDetail /> }
        { isSelectedType(ObservatoryType.Camera) && <CameraDetail /> }
        { isSelectedType(ObservatoryType.Tide) && <StageDetail /> }
        { isSelectedType(ObservatoryType.Pump) && <PumpDetail /> }
        { isSelectedType(ObservatoryType.Suijin) && <SuijinDetail /> }
        { isSelectedType(ObservatoryType.Underpass) && <UnderpassDetail /> }
      </Stack>
    </Paper>
  )
}
